import React from 'react';
import moment from 'moment';
import DOMPurify from 'dompurify';
import './chatbot.css';

/**
 * Componente de mensagem individual
 * Suporta markdown básico e formatação
 * Usa DOMPurify para proteção contra XSS
 */
const ChatMessage = ({ message }) => {
  const { role, content, isBot, timestamp, error } = message;

  // Formatar mensagem (markdown simples)
  const formatContent = (text) => {
    if (!text) return '';

    return text
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="chat-link">$1</a>') // [texto](url)
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // **negrito**
      .replace(/\*(.*?)\*/g, '<em>$1</em>') // *itálico*
      .replace(/\n/g, '<br />') // quebras de linha
      .replace(/• /g, '<span class="bullet">•</span> '); // bullets
  };

  return (
    <div className={`chatbot-message ${isBot ? 'bot' : 'user'} ${error ? 'error' : ''}`}>
      {isBot && (
        <div className="message-avatar">
          <i className="fa fa-robot" />
        </div>
      )}

      <div className="message-content">
        <div className="message-bubble">
          <div
            className="message-text"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(formatContent(content), {
                ALLOWED_TAGS: ['strong', 'em', 'br', 'a', 'span'],
                ALLOWED_ATTR: ['href', 'target', 'rel', 'class']
              })
            }}
          />
        </div>

        {timestamp && (
          <span className="message-time">
            {moment(timestamp).format('HH:mm')}
          </span>
        )}
      </div>

      {!isBot && (
        <div className="message-avatar user-avatar">
          <i className="fa fa-user" />
        </div>
      )}
    </div>
  );
};

export default ChatMessage;
